import Dialog from 'sharedComponents/Dialog';
import WarningIcon from '@mui/icons-material/Warning';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { closeButtonMessage } from 'locales/buttons';
import { FormattedMessage, useIntl } from 'react-intl';

const MultiSitePopup = ({ open, onClose, currentState, statusChanged }) => {
  const intl = useIntl();

  return (
    <Dialog
      open={open}
      title={
        <Typography variant="h6" sx={{ color: 'warning.main', display: 'flex', alignItems: 'center' }}>
          <WarningIcon sx={{ mr: 1 }} />
          {intl.formatMessage({ id: 'App-multiSite-popup-title', defaultMessage: 'Site status' })}
        </Typography>
      }
      cancelButtonLabel={intl.formatMessage(closeButtonMessage)}
      onClose={onClose}
      maxWidth={'sm'}
    >
      {statusChanged ? (
        <FormattedMessage
          id="App-multiSite-popup-description-changed"
          defaultMessage="The site status has changed to "
          values={{ status: currentState.state }}
        />
      ) : (
        <FormattedMessage
          id="App-multiSite-popup-description-initial"
          defaultMessage="The site status is "
          values={{ status: currentState.state }}
        />
      )}
      <Chip
        sx={{ backgroundColor: currentState.state === 'Active' ? 'success.main' : 'warning.main' }}
        label={currentState.state}
      />
    </Dialog>
  );
};

export default MultiSitePopup;
